<template>
  <div class="router-vertical-tabs">
    <slot :current-tab="routeFullPath" />
  </div>
</template>

<script lang="ts" setup>
import { computed, provide } from "vue";
import { useRouter } from "vue-router";

const emit = defineEmits<{
  (eventName: "update:modelValue", value: string): void;
}>();

const router = useRouter();
const routeFullPath = computed(() => router.currentRoute.value.fullPath);

provide("injectRouterVerticalTab", (data: string) => {
  router.push({ path: data });
});
</script>

<style lang="scss" scoped></style>
